module.exports = __webpack_public_path__ + "img/042-electric_tower.d2680701.svg";